import axios from 'axios'
import Cookies from 'js-cookie'

export const USER_FAKE_LOGIN = 'USER_FAKE_LOGIN'
export const USER_LOGOUT = 'USER_LOGOUT'
export const SET_LOGIN_ROLE = 'SET_LOGIN_ROLE'
export const SET_LOGIN_TOKEN = 'SET_LOGIN_TOKEN'
export const SET_ISLOGIN = 'SET_ISLOGIN'
export const ERROR = 'ERROR'
export const RECEIVE_LOGIN_PROFILE = 'RECEIVE_LOGIN_PROFILE'
export const RECEIVE_SHOW_TIMESLOT = 'RECEIVE_SHOW_TIMESLOT'
export const RECEIVE_DEFAULT_TIMESLOT = 'RECEIVE_DEFAULT_TIMESLOT'
export const SET_LANG = 'SET_LANG'
const allRole = ['student', 'tutor', 'admin']

export function setLang(lang) {
  window.localStorage.setItem('lang', lang)
  return {
    type: SET_LANG,
    lang,
  }
}

export function setLoginRole(role) {
  return {
    type: SET_LOGIN_ROLE,
    role,
  }
}

async function checkAccess(token, role, dispatch, access) {
  await Promise.all(
    allRole.map(async (requestRole) => {
      if ((role !== requestRole && access[requestRole]) === undefined) {
        const res = await axios.get(`/en/basic/api/tokenChecknValidation/${token}/${requestRole}`).then((res) => {
          return res.data.status === 'OK'
        })
        dispatch({
          type: 'ADD_ROLE',
          role: requestRole,
          res,
        })
      }
    })
  )
}

export function setLoginRoleAndVerify(role, token) {
  return async (dispatch, getState) => {
    if (!token) return

    const r = getState().login.role
    const t = getState().login.token
    const access = getState().login.access
    let res
    try {
      res = await axios.get(`/en/basic/api/tokenChecknValidation/${token}/${role}`)
    } catch (err) {
      // console.log(err)
      window.localStorage.setItem('role', 'student')
      //window.location.reload()
      dispatch(pop_alert('切換角色失敗', false))
     
      return
    }
    if (res.data.status === 'OK') {
      if (r !== role) dispatch(setLoginRole(role))
      if (t !== token)
        dispatch({
          type: SET_LOGIN_TOKEN,
          token,
        })
      dispatch(receiveProfile(res.data.result.result))
      window.localStorage.setItem('role', role)

      await checkAccess(token, role, dispatch, access)
    } else {
      window.localStorage.setItem('role', 'student')
      //window.location.reload()
      alert('你沒有權限')
    }
  }
}

export function setLoginToken(token) {
  return async (dispatch, getState) => {
    const access = getState().login.access
    await checkAccess(token, null, dispatch, access)

    Cookies.remove('token')
    dispatch({
      type: SET_LOGIN_TOKEN,
      token,
    })
  }
}

export function setIsLogin(role) {
  return {
    type: SET_ISLOGIN,
    role,
  }
}

export function setError(msg) {
  return {
    type: ERROR,
    msg,
  }
}

function receiveProfile(res) {
  return {
    type: RECEIVE_LOGIN_PROFILE,
    data: res,
  }
}

export function fetchProfile(token) {
  return (dispatch) => {
    return axios
      .get('/en/basic/api/tokenChecknValidation/' + token)
      .then((res) => {
        if (res.data.status === 'OK') dispatch(receiveProfile(res.data.result.result))
        else {
          dispatch(userLogout())
          alert(res.data.result)
        }
      })
      .catch((e) => {
        // console.log(e)
        dispatch(userLogout())
        alert('登入錯誤')
      })
  }
}

function logoutSuccess() {
  Cookies.remove('token')
  Cookies.remove('basic_token')
  window.localStorage.removeItem('role')
  return {
    type: USER_LOGOUT,
  }
}

export function userLogout() {
  return (dispatch, getState) => {
    if (process.env.NODE_ENV !== 'production') return dispatch(logoutSuccess())
    else if (getState().login.token)
      return axios
        .get('/en/basic/api/signout')
        .then((res) => {
          if (res.data.status === 'OK') {
            dispatch(logoutSuccess())
          } else {
            // console.log(res.data)
            alert(res.data.result)
          }
        })
        .catch((e) => {
          // console.log(e)
          alert('登出失敗')
        })
  }
}
const FAKE_TOKEN = '48654045851eba4a015db96a980b0f0f'
export function userFakeLogin() {
  Cookies.set('basic_token', FAKE_TOKEN, { expires: 14 })
  return {
    type: USER_FAKE_LOGIN,
    login: {
      name: '',
      role: 'student',
      token: FAKE_TOKEN,
      access: { student: true },
    },
  }
}

function receiveShowTimeSlot(res) {
  return {
    type: RECEIVE_SHOW_TIMESLOT,
    data: res,
  }
}

export function fetchShowTimeSlot() {
  return (dispatch, getState) => {
    return axios
      .get('/en/basic/api/get_defaultTimeSlot')
      .then((res) => {
        if (res.data.status === 'OK') {
          dispatch(receiveShowTimeSlot(res.data.result))
          return res.data.result
        } else dispatch(setError('獲取顯示時段資料失敗'))
      })
      .catch((e) => {
        dispatch(setError('獲取顯示時段資料失敗'))
      })
  }
}

function receiveDefaultTimeSlot(res) {
  return {
    type: RECEIVE_DEFAULT_TIMESLOT,
    data: res,
  }
}

export function fetchDefaultTimeSlot() {
  return (dispatch, getState) => {
    return axios
      .get('/en/basic/api/getTimeSlotList')
      .then((res) => {
        if (res.data.status === 'OK') {
          dispatch(receiveDefaultTimeSlot(res.data.result))
          return res.data.result
        } else dispatch(setError('獲取預設時段資料失敗'))
      })
      .catch((e) => {
        dispatch(setError('獲取預設時段資料失敗'))
      })
  }
}

// dashboard
export const RECEIVE_NEWS = 'RECEIVE_NEWS'
export const RECEIVE_URGENT = 'RECEIVE_URGENT'
export const RECEIVE_FAQ = 'RECEIVE_FAQ'
export const RECEIVE_IMPORTANTDOCUMENT = 'RECEIVE_IMPORTANTDOCUMENT'
export const RECEIVE_NORMALDOCUMENT = 'RECEIVE_NORMALDOCUMENT'
export const RECEIVE_SEMESTER = 'RECEIVE_SEMESTER'
export const RECEIVE_SUSPEND = 'RECEIVE_SUSPEND'
export const RECEIVE_TUTOR = 'RECEIVE_TUTOR'
export const RECEIVE_SUBJECT = 'RECEIVE_SUBJECT'
export const RECEIVE_TIMETABLE = 'RECEIVE_TIMETABLE'
export const POP_ALERT = 'POP_ALERT'

function receiveNews(res) {
  return {
    type: RECEIVE_NEWS,
    data: res,
  }
}

function receiveUrgent(res) {
  return {
    type: RECEIVE_URGENT,
    data: res,
  }
}

function receiveFaq(res) {
  return {
    type: RECEIVE_FAQ,
    data: res,
  }
}

function receiveNormaldocs(res) {
  return {
    type: RECEIVE_NORMALDOCUMENT,
    data: res,
  }
}

function receiveImportantdocs(res) {
  return {
    type: RECEIVE_IMPORTANTDOCUMENT,
    data: res,
  }
}

function receiveSemester(res, current) {
  return {
    type: RECEIVE_SEMESTER,
    data: res,
    current,
  }
}

function receiveSuspend(res) {
  return {
    type: RECEIVE_SUSPEND,
    data: res,
  }
}

function receiveTutor(res) {
  return {
    type: RECEIVE_TUTOR,
    data: res,
  }
}

function receiveSubject(res) {
  return {
    type: RECEIVE_SUBJECT,
    data: res,
  }
}

function receiveTimetable(res) {
  return {
    type: RECEIVE_TIMETABLE,
    data: res,
  }
}

export function pop_alert(msg, success = true) {
  return {
    type: POP_ALERT,
    msg,
    success,
  }
}

export function fetchNews(count = 99999, page = 1) {
  return (dispatch, getState) => {
    let token = getState().login.token
    return axios
      .get('/en/basic/api/getArticleList/' + token, {
        params: {
          count,
          page,
        },
      })
      .then((res) => {
        if (res.data.status === 'OK') dispatch(receiveNews(res.data.result.articleList))
        else dispatch(pop_alert('獲取最新消息列表失敗', false))
      })
      .catch((e) => {
        // console.log(e)
        dispatch(pop_alert('獲取最新消息列表失敗', false))
      })
  }
}

export function fetchUrgent(count = 99999, page = 1) {
  return (dispatch, getState) => {
    let token = getState().login.token
    return axios
      .get('/en/basic/api/getNewsList/' + token, {
        params: {
          count,
          page,
        },
      })
      .then((res) => {
        if (res.data.status === 'OK') dispatch(receiveUrgent(res.data.result.newsList))
        else dispatch(pop_alert('獲取緊急消息列表失敗', false))
      })
      .catch((e) => {
        dispatch(pop_alert('獲取緊急消息列表失敗', false))
      })
  }
}

export function fetchFaq() {
  return (dispatch, getState) => {
    let token = getState().login.token
    return axios
      .get('/en/basic/api/getQnaList/' + token)
      .then((res) => {
        if (res.data.status === 'OK') dispatch(receiveFaq(res.data.result.qnaList))
        else dispatch(pop_alert('獲取FAQ列表失敗', false))
      })
      .catch((e) => {
        dispatch(pop_alert('獲取FAQ列表失敗', false))
      })
  }
}

export function fetchImportantdocs() {
  return (dispatch, getState) => {
    let token = getState().login.token
    return axios
      .get('/en/basic/api/getDownload_documentList/' + token + '?filter[type]=重要法規')
      .then((res) => {
        if (res.data.status === 'OK') dispatch(receiveImportantdocs(res.data.result.download_documentList))
        else dispatch(pop_alert('獲取重要法規列表失敗', false))
      })
      .catch((e) => {
        dispatch(pop_alert('獲取重要法規列表失敗', false))
      })
  }
}

export function fetchNormaldocs() {
  return (dispatch, getState) => {
    let token = getState().login.token
    return axios
      .get('/en/basic/api/getDownload_documentList/' + token + '?filter[type]=常用表單')
      .then((res) => {
        if (res.data.status === 'OK') dispatch(receiveNormaldocs(res.data.result.download_documentList))
        else dispatch(pop_alert('獲取線上教材列表失敗', false))
      })
      .catch((e) => {
        dispatch(pop_alert('獲取線上教材列表失敗', false))
      })
  }
}

export function fetchSemester(title, count = 99999, page = 1) {
  return (dispatch, getState) => {
    let token = getState().login.token
    return axios
      .get('/en/basic/api/getSemesterList/' + token, {
        params: {
          count,
          page,
          'filter[title]': title,
        },
      })
      .then((res) => {
        if (res.data.status === 'OK')
          dispatch(
            receiveSemester(
              res.data.result.semesterList.sort((a, b) => (a.title < b.title ? -1 : 1)),
              res.data.result.current_semester
            )
          )
        else dispatch(pop_alert('獲取學期列表失敗', false))
      })
      .catch((e) => {
        dispatch(pop_alert('獲取學期列表失敗', false))
      })
  }
}

export function fetchSuspend(count = 99999, page = 1) {
  return (dispatch, getState) => {
    let token = getState().login.token
    return axios
      .get('/en/basic/api/getClosetimeList/' + token, {
        params: {
          count,
          page,
        },
      })
      .then((res) => {
        if (res.data.status === 'OK') dispatch(receiveSuspend(res.data.result.closetimeList))
        else dispatch(pop_alert('獲取停課列表失敗', false))
      })
      .catch((e) => {
        dispatch(pop_alert('獲取停課列表失敗', false))
      })
  }
}

export function fetchTutor(name, account, count = 99999, page = 1) {
  return (dispatch, getState) => {
    let token = getState().login.token
    return axios
      .get('/en/basic/api/getTutorList/' + token, {
        params: {
          count,
          page,
          'filter[name]': name,
          'filter[account_no]': account,
        },
      })
      .then((res) => {
        if (res.data.status === 'OK') dispatch(receiveTutor(res.data.result.tutorList))
        else dispatch(pop_alert('獲取小老師列表失敗', false))
      })
      .catch((e) => {
        dispatch(pop_alert('獲取小老師列表失敗', false))
      })
  }
}

export function fetchSubject(count = 99999, page = 1) {
  return (dispatch, getState) => {
    let token = getState().login.token
    return axios
      .get('/en/basic/api/getSubjectList/' + token, {
        params: {
          count,
          page,
        },
      })
      .then((res) => {
        if (res.data.status === 'OK') dispatch(receiveSubject(res.data.result.subjectList))
        else dispatch(pop_alert('獲取科目列表失敗', false))
      })
      .catch((e) => {
        dispatch(pop_alert('獲取科目列表失敗', false))
      })
  }
}

export function fetchTimeTable(count = 99999, page = 1) {
  return (dispatch, getState) => {
    let token = getState().login.token
    return axios
      .get('/en/basic/api/getTimetableList/' + token, {
        params: {
          count,
          page,
        },
      })
      .then((res) => {
        if (res.data.status === 'OK') dispatch(receiveTimetable(res.data.result.timetableList))
        else dispatch(pop_alert('獲取課表列表失敗', false))
      })
      .catch((e) => {
        dispatch(pop_alert('獲取課表列表失敗', false))
      })
  }
}
